export default __webpack_public_path__ + "static/media/tale03.29fb9b31.png";